import {FC} from "react";
import {KCTEventDto, ParticipantAdminDto} from "../../types/contracts";
import {useEventsContext} from "../../providers/EventsProvider";

interface ParticipantsTableProps {
    participants: ParticipantAdminDto[];
    generateNewCode: (id: string) => void;
    openModal: (participant: ParticipantAdminDto) => void;
    openModalAdditionalServices: (participant: ParticipantAdminDto) => void;
    events: KCTEventDto[] | null;
    isLoading: boolean;
    selectedValue: string;
}

const ParticipantsTable: FC<ParticipantsTableProps> = ({participants, openModal, openModalAdditionalServices, events, isLoading, selectedValue}) => {
    let content;

    const {
        selectedEvent
    } = useEventsContext()

    if (events === null || selectedValue === '') {
        content = <div className="text-center">Nejprve vyberte akci.</div>;
    } else if (isLoading && participants.length === 0) {
        content = <div className="text-center">Načítám data účastníků...</div>;
    } else if (participants.length === 0) {
        content = <div className="text-center">Žádní účastníci pro tuto akci.</div>;
    } else {
        content = (
            <table
                className="min-w-full border-separate whitespace-nowrap bg-white border"
                style={{borderSpacing: 0}}
            >
                <thead className="border">
                <tr>
                    <th className="py-2 border sticky left-0 z-10 bg-white" style={{minWidth: "100px"}}>Jméno</th>
                    <th className="py-2 border sticky left-[100px] z-10 bg-white" style={{minWidth: "100px"}}>Příjmení
                    </th>
                    <th className="py-2 border">Adresa</th>
                    <th className="py-2 border">Datum narození</th>
                    <th className="py-2 border">Email</th>
                    <th className="py-2 border">Tel. číslo</th>
                    <th className="py-2 border">Druh členství</th>
                    <th className="py-2 border">Datum a čas registrace</th>
                    <th className="py-2 border">Číslo objednávky</th>
                    <th className="py-2 border">Celková částka</th>
                    <th className="py-2 border">Číslo průkazu KČT</th>
                    <th className="py-2 border">Číslo OP/pasu</th>
                    <th className="py-2 border">Organizace</th>
                    <th className="py-2 border">Dny</th>
                    <th className="py-2 border">Počet služeb</th>
                    <th className="py-2 border">Akce</th>
                </tr>
                </thead>
                <tbody>
                {participants.map((participant, index) => (
                  <tr key={index} className="text-center bg-white hover:bg-gray-200 hover:cursor-pointer">
                      <td className="py-1 border sticky left-0 z-10 bg-inherit" style={{width: "100px"}}
                          onClick={() => openModalAdditionalServices(participant)}>{participant.name}</td>
                      <td className="py-1 border sticky left-[100px] z-10 bg-inherit" style={{width: "100px"}}
                          onClick={() => openModalAdditionalServices(participant)}>{participant.lastname}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.address}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.dateOfBirth?.toString()}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.email}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.phoneNumber}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.feeTypeName}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.registrationDate}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.orderNumber}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.orderAmount} {selectedEvent?.currency}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.membershipCardNumber}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.identityCardNumber}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.organizationName}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.stayDates}</td>
                      <td className="py-1 border"
                          onClick={() => openModalAdditionalServices(participant)}>{participant.additionalServices.length}</td>
                      <td className="py-2 border">
                          <button className="px-4 py-2 w-full bg-blue-500 text-white rounded"
                                  onClick={() => openModal(participant)}>QR
                          </button>
                      </td>
                  </tr>
                ))}
                </tbody>
            </table>
        );
    }

    return content;
};

export default ParticipantsTable;
